import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/constrainable/styles.scss';export default {
  "constrainable": "_constrainable_19dsw_1",
  "origin": "_origin_19dsw_14",
  "target": "_target_19dsw_18",
  "hovered": "_hovered_19dsw_22"
};